// extracted by mini-css-extract-plugin
export default {"root":"Flex_root__Tm5y9","variant2":"Flex_variant2__NPbjc","movein":"Flex_movein__M6geI"};